//
// Module for the Fund Batch Correspondence Review Distribution Tab view
//
rs.module("content/fund/account/correspondencereview/batchreviewdetail/distribution",

    [ "common/visibility", "common/select-helper" ],

    function (visibility, selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, distributionMethods, distributedBatchOptionFormActions) {

            // Unpack filter js selectors
            var criteria = $.js(jsSelectors.criteria);

            // Distribute Batch card js selectors
            var distributionMethodSelect = criteria.js(jsSelectors.distributionMethodSelect, { required: false });
            var emailContainer = criteria.js(jsSelectors.emailContainer, { required: false });
            var emailFields = criteria.js(jsSelectors.emailFields, { multiple: true, required: false });

            // Distribute Batch Options card js selectors
            var distributedBatchOptionsForm = criteria.js(jsSelectors.distributedBatchOptionsForm, { required: false });
            var releaseRadioBtn = criteria.js(jsSelectors.releaseRadioBtn, { required: false });
            var reprintRadioBtn = criteria.js(jsSelectors.reprintRadioBtn, { required: false });
            var reprintFieldContainer = criteria.js(jsSelectors.reprintFieldContainer, { required: false });
            var printerSelect = criteria.js(jsSelectors.printerSelect, { required: false });
            var reprintFields = criteria.js(jsSelectors.reprintFields, { multiple: true, required: false });

            // Enable JS for Distribute Batch card
            if (distributionMethodSelect) {
                // On distribution method change, affect email field visibility
                distributionMethodSelect.change(function () {
                    var isDefault = distributionMethodSelect.val() == distributionMethods.defaultMethod
                    visibility.setVisible(emailContainer, isDefault);
                    emailFields.val('');
                });
            }

            // Enable JS for Distribute Batch Options card
            if (releaseRadioBtn) {

                var printerSelectHelper = selectHelper.getHelper(printerSelect);

                releaseRadioBtn.change(function () {
                    if ($(this).is(":checked")) {
                        distributedBatchOptionsForm.attr("action", distributedBatchOptionFormActions.releaseToImaging);
                        printerSelectHelper.setDisabled(true);
                        reprintFields.prop('disabled', true);
                        visibility.hide(reprintFieldContainer);
                    }
                });

                reprintRadioBtn.change(function () {
                    if ($(this).is(":checked")) {
                        distributedBatchOptionsForm.attr("action", distributedBatchOptionFormActions.reprint);
                        printerSelectHelper.setDisabled(false);
                        reprintFields.prop('disabled', false);
                        visibility.show(reprintFieldContainer);
                    }
                });
			}
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);